// extracted by mini-css-extract-plugin
export default {"list":"NotificationButtonList_list__2bPa4","button":"NotificationButtonList_button__fSfdn","preloaderWrapper":"NotificationButtonList_preloaderWrapper__hqdnH"};